// extracted by mini-css-extract-plugin
module.exports = {"container":"Terms_container__3AfTA","address":"Terms_address__1wu2j"};